import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"vietnamese\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"900\"],\"variable\":\"--font-montserrat\",\"display\":\"swap\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutManager"] */ "/vercel/path0/src/components/layout/layout-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootProvider"] */ "/vercel/path0/src/components/layout/root-provider.tsx");
